/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Älä myy tai jaa henkilökohtaisia tietojani",
      "Bumble Date",
      "Sovelluksemme",
      "Tietoa meistä",
      "Työpaikat",
      "Ota yhteyttä",
      "Sijoittajat",
      "Kauppa",
      "Yritys",
      "Lataa sovellus",
      "Saavutettavuus Bumblessa",
      "Yhteisöohjeet",
      "Evästeasetukset",
      "Modernia orjuutta koskeva laki",
      "Tietojen kerääminen",
      "Tietosuojakäytäntö",
      "Käyttöehdot",
      "Oikeudelliset tiedot",
      "Washingtonin kuluttajien terveystietojen tietosuoja",
      "Skannaa QR-koodi saadaksesi Bumble-sovelluksen",
      "Päätä sopimukset tästä",
      "Sulje valikko",
      "Avaa valikko",
      "Kielivalinnat",
      "Alatunniste",
      "Saavutettavuus Bumblessa",
      "Apple ja Apple-logo ovat Apple Inc:n tavaramerkkejä.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Työpaikat",
      "Google Play on Google LLC:n tavaramerkki.",
      "Käyttöohjeet",
      "Sijoittajat",
      "Hallinnoi evästeitä",
      "Lausunto nykyajan orjuudesta",
      "Tietojen kerääminen",
      "Tietosuoja",
      "Kausiluontoisia deittioppaita",
      "Käyttöehdot",
      "Appi",
      "Washingtonin kuluttajien terveystietojen tietosuoja",
      "Yleistä",
      "Tuote-edustajat",
      "Laajenna ystäväpiiriäsi ja löydä yhteisösi",
      "Verkostoidu ammatillisesti ja tee urasiirtoja",
      "Löydä parisuhde, jotain rennompaa tai mitä tahansa siltä väliltä",
      "Buzz",
      "Lisätietoa",
      "Seikkaile maailmalla Matkatilassa",
      "Date",
      "Ominaisuudet",
      "Compliments",
      "Erotu muista Complimentsin, eli kehujen avulla.",
      "Discover",
      "Sinulle räätälöity sivu, josta löydät sinulle sopivimmat henkilöt – uusia profiileja päivittäin.",
      "Incognito-tila",
      "Piilota profiilisi pomoltasi, sukulaisiltasi tai exiltäsi Incognito-tilalla.",
      "Luo yhteys heti",
      "Luistiko juttu jonkun kanssa Bumblen IRL-tapahtumassa? Jatka samaan malliin sovelluksessa!",
      "Opening Moves",
      "<b>Opening Movesin</b> avulla yhteytesi voi aloittaa keskustelun, jotta sinun ei tarvitse.",
      "Poissaolotila",
      "Poissaolotilalla voit pitää taukoa deittailusta. Toivotamme sinut aina ilolla takaisin.",
      "SuperSwipe",
      "Natsasiko joku täysillä? Kerro se SuperSwipellä.",
      "Matkatila",
      "Matkatilassa löydät verottomien herkkujen lisäksi yhteyksiä maailmalta.",
      "Videopuhelu",
      "Käytä videopuheluja ja äänipuheluja selvittääksesi, oletko valmis tapaamaan kasvokkain.",
      "Verkkosovellus",
      "Nauti Bumble-kokemuksesta suoraan selaimestasi",
      "Hanki Bumble-sovellus",
      "BFF",
      "Turvallisuus",
      "Tarinat",
      "Tuki",
      "Kauppa",
      "Päävalikko",
      "Erotu edukseksi Complimentsin, eli kehujen avulla.",
      "Compliments",
      "Ominaisuuksia, jotka on suunniteltu luomaan tilaa aidoille, kunnioittaville ja merkityksellisille yhteyksille.",
      "Piilota profiilisi pomoltasi, sukulaisiltasi tai exiltäsi.",
      "Incognito-tila",
      "Poissaolotilan avulla voit pitää taukoa deittailusta.",
      "Poissaolotila",
      "Näitkö jonkun, josta pidät? Kerro se hänelle.",
      "SuperSwipe",
      "Tutustu Date-tilaan",
      "Löydä verottomien herkkujen lisäksi uusia yhteyksiä ympäri maailmaa.",
      "Matkatila",
      "Koe aito kohtaaminen ilman, että poistut kotoa.",
      "Videopuhelut",
      "Lähettiläämme auttavat tuomaan Bumblen arvoja omiin yhteisöihinsä ympäri maata.",
      "Yhteisön lähettiläät",
      "Ominaisuuksia, jotka auttavat sinua löytämään omat ihmisesi ja tutustumaan heihin yhteisten kiinnostusten kautta.",
      "Järjestä ryhmätapaaminen tai löydä paikallisia tapahtumia läheltäsi.",
      "Plans",
      "Tutustu BFF:ään",
      "Neuvoja ja inspiraatiota rakkauden ja ystävyyssuhteiden etsimiseen.",
      "Neuvoja ja tarinoita, jotka auttavat rakentamaan juuri sinulle sopivia ystävyyssuhteita.",
      "Ystävyyspaja",
      "Tokiosta Torontoon, tutustu Bumblessa alkaneisiin rakkaustarinoihin ympäri maailmaa.",
      "Rakkaustarinoita",
      "Suunnittele täydelliset treffit – ajasta, paikasta tai treffiseurasta riippumatta.",
      "Deittailuoppaat eri vuodenaikoihin",
      "Tutustu Tarinat-osioon",
      "Lue lisää",
      "Bumble {{social_network}} alustalla",
      "Yhteystiedot",
      "Kirjaudu sisään",
      "(opens in new window)",
      "UKK",
      "Cookie Policy",
      "Bumble - The Blog",
      "Työt",
      "Chattaa",
      "Kaupunkeja",
      "Hallinnoi evästeitä",
      "Copyright © 2006 – tähän päivään. Bumble. Kaikki oikeudet pidätetään.",
      "Deittailuraportti",
      "Apple ja Apple-logo ovat Apple Inc:n tavaramerkkejä.{{__EOL__}}Google Play on Google LLC:n tavaramerkki.",
      "Lataa",
      "Facebook",
      "Seuraa meitä",
      "Asiakastuki",
      "Instagram",
      "Kieli",
      "LinkedIn",
      "Bumble-palvelun tarjoaa Bumble Inc.",
      "Tietosuoja",
      "Turvallisuuskeskus",
      "Sivustokartta",
      "Lausunto nykyajan orjuudesta",
      "Käyttöehdot",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "päivää",
                  "päivää",
                  "päivän",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää"
            ],
            "singular": [
                  "päivä",
                  "päivä",
                  "päivän",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä"
            ]
      },
      "hour": {
            "plural": [
                  "tuntia",
                  "tuntia",
                  "tunnin",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia"
            ],
            "singular": [
                  "tunti",
                  "tunti",
                  "tunnin",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti"
            ]
      },
      "minute": {
            "plural": [
                  "minuuttia",
                  "minuuttia",
                  "minuutin",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia"
            ],
            "singular": [
                  "minuutti",
                  "minuutti",
                  "minuutin",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti"
            ]
      },
      "month": {
            "plural": [
                  "kuukautta",
                  "kuukautta",
                  "kuukauden",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta"
            ],
            "singular": [
                  "kuukausi",
                  "kuukausi",
                  "kuukauden",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi"
            ]
      },
      "second": {
            "plural": [
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia"
            ],
            "singular": [
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti"
            ]
      },
      "year": {
            "plural": [
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta"
            ],
            "singular": [
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
